import React from 'react';
import { Box, Typography, Button, List, ListItem, ListItemIcon, ListItemText, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import CheckIcon from '@mui/icons-material/Check';
import { COLORS, fontFamilyAll } from '../assets/commonComponents/COLORS';
import aboutUsImage from '../assets/images/aboutUs.jpg';

export default function AboutCard({ isMobile, data }) {
    return (
        <Box sx={{ backgroundColor: COLORS.aboutbgColor, py: { xs: 4, md: 8 }, px: { xs: 3, md: 6 } }}>
            <Grid container spacing={6} alignItems="center">
                {/* Left Section - Image */}
                <Grid item xs={12} md={5} display="flex" justifyContent={{ xs: 'center', md: 'flex-start' }}>
                    <Box
                        component="img"
                        src={aboutUsImage}
                        alt="About Us"
                        sx={{
                            width: { xs: '100%', sm: 400, md: 480 },
                            height: 'auto',
                            borderRadius: 2,
                            boxShadow: 3,
                            objectFit: 'cover',
                        }}
                    />
                </Grid>
                
                {/* Right Section - Text Content */}
                <Grid item xs={12} md={7}>
                    <Typography 
                        variant="h6" 
                        fontWeight={700} 
                        textAlign={{ xs: 'center', md: 'left' }} 
                        gutterBottom 
                        sx={{ color: COLORS.primaryColor }}
                                 fontFamily={fontFamilyAll}
                        
                    >
                        {data.title}
                    </Typography>
                      <Typography 
                        variant="h4" 
                        fontWeight={700} 
                        textAlign={{ xs: 'center', md: 'left' }} 
                        gutterBottom 
                        sx={{ color: COLORS.blackColor }}
                                 fontFamily={fontFamilyAll}
                        
                    >
                        {data.subtitle}
                    </Typography>
                    
                    <Typography
                        variant="body1"
                        textAlign={{ xs: 'center', md: 'justify' }}
                        sx={{ color: COLORS.aboutDescriptionColor, lineHeight: 1.8, mb: 3 }}
                                 fontFamily={fontFamilyAll}
                        
                    >
                        {data.description}
                    </Typography>
                    
                    <List sx={{ pl: 2 }}>
                        {data.bulletPoints.map((text, index) => (
                            <ListItem key={index} sx={{ padding: 0, mb: 1 }}>
                                <ListItemIcon>
                                    <CheckIcon sx={{ color: COLORS.primaryColor }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={text}
                                             fontFamily={fontFamilyAll}
                                    
                                    primaryTypographyProps={{ variant: 'body1', sx: { color: COLORS.aboutListColor,  fontFamily:` ${fontFamilyAll} !important`,
                                } }}
                                />
                            </ListItem>
                        ))}
                    </List>

                    <motion.div style={{ display: 'flex', justifyContent: { xs: 'center', md: 'center' },alignItems: { xs: 'center', md: 'center' } }}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: COLORS.primaryColor,
                                color: '#fff',
                                borderRadius: 2,
                                padding: '12px 32px',
                                textTransform: 'none',
                                fontSize: '16px',
                                fontWeight: 600,
                                mt: 3,
                                position: 'relative',
                                overflow: 'hidden',
                                fontFamily:` ${fontFamilyAll} !important`,

                                transition: 'all 0.3s ease-in-out',
                                '&:hover': {
                                    backgroundColor: COLORS.primaryColor,
                                    transform: 'translateY(-2px)',
                                },
                            }}
                        >
                            {data.buttonText}
                        </Button>
                    </motion.div>
                </Grid>
            </Grid>
        </Box>
    );
}